import React from 'react';
import { Table } from 'react-bootstrap';
import { SelectComponent } from "./SelectComponent";

function renderPredicateValueSelect(predicateName, predicateValues, params, domain, onInputChange, disabled, value, index) {
  return /*#__PURE__*/React.createElement("select", {
    onChange: e => changeValue(onInputChange, e.target.value, params, index, predicateName),
    value: value
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, ''), domain.map(item => /*#__PURE__*/React.createElement("option", {
    key: item,
    disabled: disabled,
    value: item
  }, item)));
}

function changeValue(onInputChange, value, params, index, predicateName) {
  if (value === params[index]) {
    return;
  }

  onInputChange(params, predicateName, false);

  if (value !== '') {
    params[index] = value;
    onInputChange(params, predicateName, true);
  }
}

export function DatabasePredicate(props) {
  let domain = [...props.domain];

  if (props.selectionElement === undefined) {
    props = Object.assign({
      selectionElement: Array(parseInt(props.arity))
    }, props);
    props.selectionElement.fill("");
  }

  let element = predicateArrayElements => /*#__PURE__*/React.createElement("tbody", null, predicateArrayElements.map((onePredicateArray, count) => /*#__PURE__*/React.createElement("tr", {
    key: 'database-predicate-row' + count
  }, onePredicateArray.map((domainElement, index) => /*#__PURE__*/React.createElement("td", {
    key: 'database-predicate-column' + index
  }, renderPredicateValueSelect(props.name, props.value, [...onePredicateArray], domain, props.onInputChange, props.disabled, domainElement, index))))), newSelectionElement()); //ak je props.arity string tak to nevytvori pole danej velkost, teda to treba najprv parsnut


  let newSelectionElement = () => /*#__PURE__*/React.createElement("tr", null, props.selectionElement.map((value, index) => /*#__PURE__*/React.createElement(SelectComponent, {
    key: 'select-component' + index,
    domain: domain,
    index: index,
    props: props
  })));

  let headElements = () => /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, [...Array(parseInt(props.arity))].map((x, count) => /*#__PURE__*/React.createElement("th", {
    key: "m" + (count + 1),
    className: "interpretationHead"
  }, /*#__PURE__*/React.createElement("var", null, "m"), /*#__PURE__*/React.createElement("sub", null, count + 1)))));

  if (Array.isArray(props.value)) {
    return /*#__PURE__*/React.createElement(Table, {
      bordered: true,
      responsive: true,
      size: "sm",
      className: "small"
    }, headElements(), element(props.value));
  } else {
    return /*#__PURE__*/React.createElement(Table, {
      bordered: true,
      responsive: true
    }, headElements(), /*#__PURE__*/React.createElement("tbody", null, newSelectionElement()));
  }
}